export default {
    install(Vue) {
        Vue.prototype.rsarequre = function(data, url, callback, type1) {

            var urlrequery = this.$store.state.p_url + url;
            this.$axios({
                url: urlrequery,
                method: "POST",
                data: data,

            }).then(res => {
                callback(res);
                // var errcodelogin = res.data.errcode;
                if (Number(res.data.code) == 30001) {
                    $('.shadedianshow').fadeIn();
                }
            })
        }


    }
}


// WEBPACK FOOTER //
// ./src/assets/js/requshare.js